module.exports = __webpack_public_path__ + "img/maozinha.9f5009a8.png";